import { Text } from '@app/components/core/typography/Text'
import { Title } from '@app/components/core/typography/Title'
import { DashboardPageLayout } from '@app/pages/layout/DashboardPageLayout'
import { useClient } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'
import { useEffect, useState } from 'react'
import { useLocation } from 'wouter'
import Column from '@app/components/layout/Column'
import { Button } from '@app/components/core/button/Button'
import { INITIATIVE_USER_ROLES } from '@schema/initiative'
import { pages } from '@app/util/links'
import Row from '@app/components/layout/Row'
import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { IconButton } from '@app/components/core/button/IconButton'
import { AdministeredInitiative } from './sections/AdministeredInitiative'
import listInitiativeFunction from 'functions/app/dashboard/profile/initiative/list/based.config'
import { DahsboardListInitiativeModel } from 'functions/app/dashboard/profile/initiative/list'
import { useUserContext } from '@app/util/hooks/useUserContext'
import useMediaQuery from '@app/util/useMediaQuery'

export const InitiativeHome = () => {
  const translations = useTranslations().app.dashboard.initiative
  const client = useClient()
  const [_location, navigate] = useLocation()
  const isMobile = useMediaQuery()

  const { authState } = useUserContext()
  const [initiatives, setInitiatives] = useState<
    DahsboardListInitiativeModel[]
  >([])

  useEffect(() => {
    const close = client
      .query(listInitiativeFunction.name, {
        userId: authState.userId,
        role: [INITIATIVE_USER_ROLES.owner, INITIATIVE_USER_ROLES.admin],
        includeNotLive: true,
        includeAllInitiativeUsers: true,
      })
      .subscribe((result) => {
        setInitiatives(result)
      })
    return () => close()
  }, [client, authState.userId])

  if (initiatives.length === 0) {
    return (
      <DashboardPageLayout>
        <Title.H3>{translations.common.myInitiatives}</Title.H3>
        <Column alignItems="center" style={{ paddingBottom: '30vh' }}>
          <Column
            alignItems="center"
            gap={'1.5rem'}
            style={{ justifyContent: 'center' }}
          >
            <Text.Medium style={{}}>
              {translations.home.noInitiativesPlaceholder}
            </Text.Medium>

            {!isMobile && (
              <Button
                label={translations.home.startInitiative}
                onClick={() => navigate(pages.dashboardStartInitiative)}
              />
            )}
          </Column>
        </Column>
      </DashboardPageLayout>
    )
  }

  return (
    <DashboardPageLayout>
      <Row style={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Title.H3 style={{ marginBottom: 0 }}>
          {translations.common.myInitiatives}
        </Title.H3>

        {!isMobile && (
          <IconButton
            icon={faPlus}
            onClick={() => navigate(pages.dashboardStartInitiative)}
          />
        )}
      </Row>
      <Column alignItems="stretch">
        {initiatives.map((initiative) => (
          <AdministeredInitiative key={initiative.id} initiative={initiative} />
        ))}
      </Column>
    </DashboardPageLayout>
  )
}
